// react and mui stuff
import Tooltip from '@mui/joy/Tooltip';

import Icon from '@mui/icons-material/Help';


type props = {
  helpText: string
}

export default function PurposeHelper(props: props) {
  return (
    <Tooltip title={props.helpText} placement='top-start' enterTouchDelay={1}>
      <div style={{ marginBottom: "15px", fontSize: "15px" }}>
        <i>What's the purpose of this section?</i>
        <sup>
          <Icon sx={{ verticalAlign: "middle", paddingLeft: "2px", height: "15px" }}/>
        </sup>
      </div>
    </Tooltip>
  )
}